namespace NasVault {
  async function jsonResponse<T>(response: Response): Promise<T> {
    const data = await response.json() as T & { error?: string };
    if (!response.ok) throw new Error(data.error || "NAS 요청을 처리하지 못했어요.");
    return data;
  }

  export const api = {
    async list(path: string): Promise<ListPayload> {
      return jsonResponse<ListPayload>(await fetch(`/api/nas/list?path=${encodeURIComponent(path)}`));
    },

    async createFolder(path: string): Promise<void> {
      await jsonResponse(await fetch("/api/nas/folder", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ path }),
      }));
    },

    async remove(path: string): Promise<void> {
      await jsonResponse(await fetch(`/api/nas/file?path=${encodeURIComponent(path)}`, { method: "DELETE" }));
    },

    upload(file: File, path: string, onProgress: (percent: number) => void): Promise<UploadResult> {
      return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        request.open("POST", "/api/nas/file");
        request.responseType = "json";
        request.upload.addEventListener("progress", (event) => {
          if (event.lengthComputable) onProgress(Math.round((event.loaded / event.total) * 100));
        });
        request.addEventListener("load", () => {
          const result = request.response as UploadResult | null;
          if (request.status >= 200 && request.status < 300 && result?.ok) {
            onProgress(100);
            resolve(result);
            return;
          }
          reject(new Error(result?.error || "업로드하지 못했어요."));
        });
        request.addEventListener("error", () => reject(new Error("NAS에 연결할 수 없어요.")));
        request.addEventListener("abort", () => reject(new Error("업로드가 취소됐어요.")));
        const form = new FormData();
        form.append("path", path);
        form.append("file", file);
        request.send(form);
      });
    },
  };
}
